const AggregatorType  = {
    AVG:    { key: 'AVG',   name: 'Average' },
    MAX:    { key: 'MAX',   name: 'Maximum' },
    MIN:    { key: 'MIN',   name: 'Minimum' },
    COUNT:  { key: 'COUNT', name: 'Count' },
    SUM:    { key: 'SUM',   name: 'Sum' }
};

export default AggregatorType;